<template>
  <div class="alert-banner">
    <UIcon :name="icon" class="size-4.5 shrink-0" />
    <span class="text-section-label min-w-0 leading-snug">{{ message }}</span>
  </div>
</template>

<script setup lang="ts">
defineProps<{ icon: string, message: string }>()
</script>

<style lang="scss" scoped>
// Same warning-banner language as MainLayout's training-banner (full-width,
// icon + text, error surface) — no dismiss action: these are notices the
// cashier must act on (a certificate, the device clock), not toggleable modes.
.alert-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  min-height: 44px;
  padding: 4px 12px 4px 16px;
  background: var(--ui-error);
  color: #ffffff;
}
</style>
